var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87934 0.990967C2.46513 0.990967 2.12934 1.32675 2.12934 1.74097C2.12934 2.15518 2.46513 2.49097 2.87934 2.49097L7.45743 2.49097L0.21967 9.72873C-0.0732233 10.0216 -0.0732233 10.4965 0.21967 10.7894C0.512563 11.0823 0.987437 11.0823 1.28033 10.7894L8.51785 3.55186V8.12948C8.51785 8.54369 8.85364 8.87948 9.26785 8.87948C9.68207 8.87948 10.0179 8.54369 10.0179 8.12948V1.74097C10.0179 1.32675 9.68207 0.990967 9.26785 0.990967L2.87934 0.990967Z",
    fill: "#EF102A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.b1e770a7f615824d17c4b90d0647c4cf.svg";
export { ForwardRef as ReactComponent };